var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"variant":"warning","show":""}},[_c('div',{staticClass:"alert-body"},[_c('p',{staticClass:"text-center"},[_c('strong',[_vm._v("This Page Is Under Construction")])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }